var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5L16 2.66675L4 12.0001V26.6667C4 27.374 4.28095 28.0523 4.78105 28.5524C5.28115 29.0525 5.95942 29.3334 6.66667 29.3334H25.3333C26.0406 29.3334 26.7189 29.0525 27.219 28.5524C27.719 28.0523 28 27.374 28 26.6667V12.0001L26 10.5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 29.3333V16H20V29.3333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7148 8.18959C17.3286 7.7948 16.6955 7.78785 16.3007 8.17406C15.9059 8.56026 15.899 9.19339 16.2852 9.58818L17.7148 8.18959ZM20.0435 12L19.3286 12.6993C19.5239 12.8989 19.7937 13.0078 20.0728 12.9996C20.3519 12.9914 20.6149 12.8669 20.7981 12.6562L20.0435 12ZM27.7546 4.65618C28.117 4.23942 28.0729 3.60779 27.6562 3.24539C27.2394 2.883 26.6078 2.92706 26.2454 3.34382L27.7546 4.65618ZM16.2852 9.58818L19.3286 12.6993L20.7583 11.3007L17.7148 8.18959L16.2852 9.58818ZM20.7981 12.6562L27.7546 4.65618L26.2454 3.34382L19.2889 11.3438L20.7981 12.6562Z",
    fill: "currentColor"
  })));
}
export default SvgFacilities;